import algoliasearch from 'algoliasearch';
import { AlgoliaAPIKey, AlgoliaAppId } from '../env';

export const algoliaClient = algoliasearch(AlgoliaAppId, AlgoliaAPIKey);
